import { render, staticRenderFns } from "./CircleCloseIcon.vue?vue&type=template&id=3991987b&"
import script from "./CircleCloseIcon.vue?vue&type=script&lang=js&"
export * from "./CircleCloseIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports